import CloseIcon from '@mui/icons-material/Close'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import type { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import { FC, useState } from 'react'

import { LuneThemeNew } from '../theme'

import IconButton from './IconButton'
import InputNew from './InputNew'

const { palette } = LuneThemeNew

const SearchInput: FC<{
    onSearch: (searchKey: string) => void
    onClear: () => void
    sx?: SxProps
    /**
     * Input placeholder text shown before the user types.
     *
     * This should usually be a short hint, not a full sentence.
     * Defaults to "Search".
     */
    placeholder?: string
}> = ({ onSearch, onClear, sx, placeholder = 'Search' }) => {
    const [value, setValue] = useState('')

    return (
        <Box sx={{ position: 'relative' }}>
            <SearchOutlinedIcon
                sx={{
                    position: 'absolute',
                    top: '10px',
                    left: '12px',
                    zIndex: 9,
                    height: '20px',
                    width: '20px',
                    fill: palette.TextTertiary,
                }}
            />
            <InputNew
                value={value}
                sx={{
                    ...sx,
                    pl: 5,
                    pr: 4,
                }}
                size={'sm'}
                placeholder={placeholder}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        onSearch(value)
                    }
                }}
                onChange={(e) => setValue(e.target.value)}
            />
            {value && value.length && (
                <IconButton
                    sx={{ position: 'absolute', right: '4px', top: '4px' }}
                    variant={'secondary'}
                    size={'sm'}
                    style={'floating'}
                    leadingIcon={<CloseIcon />}
                    onClick={() => {
                        setValue('')
                        onClear()
                    }}
                />
            )}
        </Box>
    )
}
export default SearchInput
